import { render, staticRenderFns } from "./CartsTitle.vue?vue&type=template&id=cf8beb94&scoped=true"
import script from "./CartsTitle.vue?vue&type=script&lang=js"
export * from "./CartsTitle.vue?vue&type=script&lang=js"
import style0 from "./CartsTitle.vue?vue&type=style&index=0&id=cf8beb94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf8beb94",
  null
  
)

export default component.exports